import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";
import { ANIA_ENUM } from "../util/AniaEnums";

export const itaAniaLevels = (t, title, aniaEnum) => {
  let aniaLegendTitle;
  let aniaLegendLevel;
  let explained = "(Explained here)";
  aniaLegendLevel = [t("levels.noData"), t("levels.low"), t("levels.moderate"), t("levels.high")];
  if (aniaEnum === ANIA_ENUM.ANIA_01) {
    const unit = t("riskAssessment.daysOfHighWind");
    aniaLegendTitle = title || `${t("riskAssessment.highWind")} (ITA) - (ANIA)`;

    aniaLegendLevel = [
      t("levels.noData"),
      t("levels.low_a") + " " + t("levels.severity") + " ( <1 " + unit + ")",
      t("levels.medium_a") + " " + t("levels.severity") + " ( 1-2 " + unit + ")",
      t("levels.high_a") + " " + t("levels.severity") + " ( >2 " + unit + ")",
    ];

    explained = t("legend.aniaLegendExlanation.windHazard");
  }
  if (aniaEnum === ANIA_ENUM.ANIA_02) {
    const unit = t("riskAssessment.hailEvents");
    aniaLegendTitle = title || `${t("riskAssessment.hail")} (ITA) - (ANIA)`;
    aniaLegendLevel = [
      t("levels.noData"),
      t("levels.low_a") + " " + t("levels.severity") + " ( 0-0.75 " + unit + ")",
      t("levels.medium_a") + " " + t("levels.severity") + " ( 0.75-1.25 " + unit + ")",
      t("levels.high_a") + " " + t("levels.severity") + " ( >1.25 " + unit + ")",
    ];
    explained = t("legend.aniaLegendExlanation.hail");
  }
  if (aniaEnum === ANIA_ENUM.ANIA_03) {
    const unit = t("riskAssessment.lightningStrikes");
    aniaLegendTitle = title || `${t("riskAssessment.lightningStrike")} (ITA) - (ANIA)`;
    aniaLegendLevel = [
      t("levels.noData"),
      t("levels.low_a") + " " + t("levels.severity") + " ( 0-1 " + unit + ")",
      t("levels.medium_a") + " " + t("levels.severity") + " ( 1-2 " + unit + ")",
      t("levels.high_a") + " " + t("levels.severity") + " ( >2 " + unit + ")",
    ];
    explained = t("legend.aniaLegendExlanation.lightningStrike");
  }
  if (aniaEnum === ANIA_ENUM.ANIA_04) {
    const unit = t("riskAssessment.extremePrecipitationDays");
    aniaLegendTitle = title || `${t("riskAssessment.precipitation")} 75 mm (ITA) - (ANIA)`;

    aniaLegendLevel = [
      t("levels.noData"),
      t("levels.low_a") + " " + t("levels.severity") + " ( 0-2 " + unit + ")",
      t("levels.medium_a") + " " + t("levels.severity") + " ( 2-5 " + unit + ")",
      t("levels.high_a") + " " + t("levels.severity") + " ( >5 " + unit + ")",
    ];
    explained = t("legend.aniaLegendExlanation.precipitation");
  }

  if (aniaEnum === ANIA_ENUM.ANIA_05) {
    const unit = t("riskAssessment.daysOfSnow");
    aniaLegendTitle = title || `${t("riskAssessment.precipitationSnow")} 30 cm (ITA) - (ANIA)`;

    aniaLegendLevel = [
      t("levels.noData"),
      t("levels.low_a") + " " + t("levels.severity") + " ( 0-1 " + unit + ")",
      t("levels.medium_a") + " " + t("levels.severity") + " ( 1-7 " + unit + ")",
      t("levels.high_a") + " " + t("levels.severity") + " ( >7 " + unit + ")",
    ];
    explained = t("legend.aniaLegendExlanation.precipitationSnow");
  }

  if (aniaEnum === ANIA_ENUM.ANIA_LEGEND) {
    aniaLegendTitle = title || `${t("riskAssessment.precipitationSnow")} 30 cm (ITA) - (ANIA)`;

    aniaLegendLevel = [
      t("levels.noData"),
      t("levels.veryLow") + " " + t("levels.severity") + " ( 1<=" + t("levels.indexValue") + "<=1.25)",
      t("levels.relativelyLow") +
        " " +
        t("levels.severity") +
        " (1.25<" +
        t("levels.indexValue") +
        "<= 1.75)",
      t("levels.medium_a") + " " + t("levels.severity") + " (1.75<" + t("levels.indexValue") + "<= 2.25)",
      t("levels.relativelyHigh") +
        " " +
        t("levels.severity") +
        " (2.25<" +
        t("levels.indexValue") +
        "<=2.75)",
      t("levels.veryHigh") + " " + t("levels.severity") + " (2.75<" + t("levels.indexValue") + " <= 3)",
    ];
    explained = "";
  }

  return { aniaLegendTitle, aniaLegendLevel, explained };
};

export const aniaIndexLevels = [0.9, 1.4, 1.9, 2.4, 2.9, 3.4];
//  1-1.25 1.5-1.75 2-2.25 2.5-2.75 3 in 3 level scale in all Geojson files.

export const ItaAniaWindLegend = ({ customLegendStyle = legendStyle, title, aniaEnum }) => {
  const { t } = useTranslation();
  const { aniaLegendTitle, aniaLegendLevel, explained } = itaAniaLevels(t, title, aniaEnum);
  if (
    aniaEnum !== ANIA_ENUM.ANIA_01 &&
    aniaEnum !== ANIA_ENUM.ANIA_02 &&
    aniaEnum !== ANIA_ENUM.ANIA_03 &&
    aniaEnum !== ANIA_ENUM.ANIA_04 &&
    aniaEnum !== ANIA_ENUM.ANIA_05 &&
    aniaEnum !== ANIA_ENUM.ANIA_LEGEND
  ) {
    console.error("ItaAniaWindLegend: aniaEnum is not ANIA_ENUM.ANIA_01,  ANIA_ENUM.ANIA_02, ...");
    return null;
  }

  let itemlist;
  if (aniaEnum !== ANIA_ENUM.ANIA_LEGEND) {
    itemlist = (
      <>
        <div>
          <span style={legendItemStyle("#21bf50")}></span>
          {aniaLegendLevel[1]}
        </div>
        <div>
          <span style={legendItemStyle("#f1d55d")}></span>
          {aniaLegendLevel[2]}
        </div>
        <div>
          <span style={legendItemStyle("#e07069")}></span>
          {aniaLegendLevel[3]}
        </div>

        <div>
          <span style={legendItemStyle("#ffffff")}></span>
          {aniaLegendLevel[0]}
        </div>
      </>
    );
  } else {
    itemlist = (
      <>
        <div>
          <span style={legendItemStyle("#4d6dbd")}></span>
          {aniaLegendLevel[1]}
        </div>
        <div>
          <span style={legendItemStyle("#509bc7")}></span>
          {aniaLegendLevel[2]}
        </div>
        <div>
          <span style={legendItemStyle("#f1d55d")}></span>
          {aniaLegendLevel[3]}
        </div>
        <div>
          <span style={legendItemStyle("#e07069")}></span>
          {aniaLegendLevel[4]}
        </div>
        <div>
          <span style={legendItemStyle("#a7243d")}></span>
          {aniaLegendLevel[5]}
        </div>
      </>
    );
  }

  return (
    <div style={customLegendStyle}>
      <div>
        <b>{aniaLegendTitle}</b>
      </div>

      {itemlist}

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "x-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          {explained}
        </span>
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "400px",
            lineHeight: 1,
          }}
        >
          Copyright © 2023 ANIA SAFE (Associazione Nationale fra la Impresse Assicuratrici / ANIA Servizi e
          formazione S.r.l.). {t("aniaTooltip.processed")}
        </span>
      </div>
    </div>
  );
};
